/**
 * Playready Key System.
 *
 * @group DRM
 *
 * @beta
 */
export const PLAYREADY_KEY_SYSTEM = 'com.microsoft.playready';
